import {
  FormContext
} from "../__chunks/P3I4MECH.js";
import {
  useButton
} from "../__chunks/O6CV6VRM.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-submit.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useFormSubmit = createHook(
  (_a) => {
    var _b = _a, { store, accessibleWhenDisabled = true } = _b, props = __objRest(_b, ["store", "accessibleWhenDisabled"]);
    const context = useContext(FormContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormSubmit must be wrapped in a Form component"
    );
    props = __spreadValues({
      type: "submit",
      disabled: store.useState("submitting")
    }, props);
    props = useButton(__spreadProps(__spreadValues({}, props), { accessibleWhenDisabled }));
    return props;
  }
);
var FormSubmit = createComponent((props) => {
  const htmlProps = useFormSubmit(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormSubmit.displayName = "FormSubmit";
}
export {
  FormSubmit,
  useFormSubmit
};
